// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-content > table > tbody > tr:nth-child(odd) > td,
.ant-table-content > table > tbody > tr:nth-child(odd) > th {
  background-color: rgba(15, 105, 196, 0.05);
}

.ant-modal {
  width: 95% !important;
}

.modalBtnOk {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 18px !important;
  min-width: 10rem;
  color: #fff !important;
  background: #0f69b4 !important;
}

.ant-modal .ant-modal-footer {
  display: none;
}

.ant-pagination-item-link .anticon svg {
  margin-bottom: 4px;
}

@media (min-width: 768px) {
  .ant-modal {
    width: 67% !important;
  }
}
@media (min-width: 992px) {
  .ant-modal {
    width: 54% !important;
  }
}
@media (min-width: 1200px) {
  .ant-modal {
    width: 45% !important;
  }
}
@media (min-width: 1400px) {
  .ant-modal {
    width: 40% !important;
  }
}
.btn-form span {
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.btnAzul {
  background-color: #0f69b4;
}

.btnBlanco {
  box-shadow: inset 0 0 0 0.4px #0f69b4 !important;
  color: #0f69b4 !important;
  background: transparent none !important;
}

text.registros {
  color: var(--text-medium, #4d4d4d);
  /* Desktop/H3 */
  font-family: Roboto Slab;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
}

.busqueda {
  border: 1px solid #dfdfdf;
  border-radius: 12px;
  font-family: "Roboto";
  padding-left: 14px;
  padding-right: 14px;
}
.busqueda .busqueda-selector .ant-select {
  height: 44px;
}
.busqueda .busqueda-selector .ant-select .ant-select-selector {
  border-radius: 4px;
}
.busqueda .busqueda-selector label {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #4d4d4d;
}
.busqueda .nombre-faena label,
.busqueda .rut-empresa-solicitante label,
.busqueda .razon-social-empresa-solicitante label {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #4d4d4d;
  padding-bottom: 2px;
}
.busqueda .nombre-faena input,
.busqueda .rut-empresa-solicitante input,
.busqueda .razon-social-empresa-solicitante input {
  height: 42px;
  border-radius: 4px;
  font-family: "Roboto";
  font-size: 16px;
  color: #4d4d4d;
  line-height: 20px;
}

.descripcion-registro {
  font-family: "Roboto Slab";
  color: var(--text-medium) !important;
  font-size: 16px;
}

.ant-table-wrapper {
  padding: 0px !important;
}

#tbl-registro-resoluciones .ant-table-thead {
  border: 1px solid;
  border-color: #dfdfdf;
}
#tbl-registro-resoluciones .ant-table-thead tr:first-child > *:first-child {
  border-start-start-radius: 4px;
}
#tbl-registro-resoluciones .ant-table-thead tr:first-child > *:last-child {
  border-start-end-radius: 4px;
}
#tbl-registro-resoluciones .ant-table-thead .ant-table-cell {
  background-color: #f1f1f1;
  padding: 16px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  color: #4d4d4d;
}
#tbl-registro-resoluciones .ant-table-tbody {
  border: 1px solid;
  border-color: #dfdfdf;
}
#tbl-registro-resoluciones .ant-table-tbody .ant-table-cell {
  background-color: #ffffff;
  padding: 16px;
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: #4d4d4d;
}

.ant-pagination .ant-pagination-item {
  border: 1px solid;
  border-color: #bebebe;
  border-radius: 2px;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  color: #4d4d4d;
  text-align: center;
}
.ant-pagination .ant-pagination-item-active {
  border: 1px solid;
  border-color: #0f69b4;
  border-radius: 2px;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  color: #0f69b4;
  text-align: center;
}
.ant-pagination .ant-pagination-options .ant-select-selector {
  border: 1px solid;
  border-color: #bebebe;
  border-radius: 2px;
  font-family: "Roboto";
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #4d4d4d;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/views/RegistroResolucionesJex/HistorialRegistroResoluciones/styles.scss"],"names":[],"mappings":"AAAA;;EAEE,0CAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,wIAAA;EACA,0BAAA;EACA,gBAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAGA;EACE;IACE,qBAAA;EAAF;AACF;AAKA;EACE;IACE,qBAAA;EAHF;AACF;AAQA;EACE;IACE,qBAAA;EANF;AACF;AAWA;EACE;IACE,qBAAA;EATF;AACF;AAcE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAZJ;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,gDAAA;EACA,yBAAA;EACA,uCAAA;AAbF;;AAgBA;EACE,kCAAA;EACA,eAAA;EACA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAbF;AAgBI;EACE,YAAA;AAdN;AAgBM;EACE,kBAAA;AAdR;AAmBI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAjBN;AAwBI;;;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AApBN;AAuBI;;;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAnBN;;AAyBA;EACE,0BAAA;EACA,oCAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AA4BE;EACE,iBAAA;EAEA,qBAAA;AA1BJ;AA4BI;EACE,8BAAA;AA1BN;AA6BI;EACE,4BAAA;AA3BN;AA8BI;EACE,yBAAA;EACA,aAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA7BN;AAiCE;EACE,iBAAA;EACA,qBAAA;AA/BJ;AAiCI;EACE,yBAAA;EACA,aAAA;EAEA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhCN;;AAwCE;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArCJ;AAwCE;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtCJ;AAyCE;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAvCJ","sourcesContent":[".ant-table-content>table>tbody>tr:nth-child(odd)>td,\n.ant-table-content>table>tbody>tr:nth-child(odd)>th {\n  background-color: rgba(15, 105, 196, 0.05);\n}\n\n.ant-modal {\n  width: 95% !important;\n}\n\n.modalBtnOk {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 18px !important;\n  min-width: 10rem;\n  color: #fff !important;\n  background: #0f69b4 !important;\n}\n\n.ant-modal .ant-modal-footer {\n  display: none;\n}\n\n.ant-pagination-item-link .anticon svg {\n  margin-bottom: 4px;\n}\n\n// // Medium devices (tablets, 768px and up)\n@media (min-width: 768px) {\n  .ant-modal {\n    width: 67% !important;\n    ;\n  }\n}\n\n// // Large devices (desktops, 992px and up)\n@media (min-width: 992px) {\n  .ant-modal {\n    width: 54% !important;\n    ;\n  }\n}\n\n// // X-Large devices (large desktops, 1200px and up)\n@media (min-width: 1200px) {\n  .ant-modal {\n    width: 45% !important;\n    ;\n  }\n}\n\n// // XX-Large devices (larger desktops, 1400px and up)\n@media (min-width: 1400px) {\n  .ant-modal {\n    width: 40% !important;\n  }\n}\n\n.btn-form {\n\n  span {\n    font-family: \"Roboto\";\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n  }\n}\n\n.btnAzul{\n  background-color: #0f69b4;\n}\n\n.btnBlanco {\n  box-shadow: inset 0 0 0 0.4px #0f69b4 !important;\n  color: #0f69b4 !important;\n  background: transparent none !important;\n}\n\ntext.registros {\n  color: var(--text-medium, #4d4d4d);\n  /* Desktop/H3 */\n  font-family: Roboto Slab;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 40px;\n}\n\n.busqueda {\n  border: 1px solid #dfdfdf;\n  border-radius: 12px;\n  font-family: \"Roboto\";\n  padding-left: 14px;\n  padding-right: 14px;\n\n  .busqueda-selector {\n    .ant-select {\n      height: 44px;\n\n      .ant-select-selector {\n        border-radius: 4px;\n      }\n\n    }\n\n    label {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 24px;\n      color: #4d4d4d;\n    }\n  }\n\n  .nombre-faena,\n  .rut-empresa-solicitante,\n  .razon-social-empresa-solicitante {\n    label {\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 24px;\n      color: #4d4d4d;\n      padding-bottom: 2px;\n    }\n\n    input {\n      height: 42px;\n      border-radius: 4px;\n      font-family: \"Roboto\";\n      font-size: 16px;\n      color: #4d4d4d;\n      line-height: 20px;\n    }\n  }\n\n}\n\n.descripcion-registro {\n  font-family: \"Roboto Slab\";\n  color: var(--text-medium) !important;\n  font-size: 16px;\n}\n\n.ant-table-wrapper {\n  padding: 0px !important;\n}\n\n\n#tbl-registro-resoluciones {\n\n  .ant-table-thead {\n    border: 1px solid;\n\n    border-color: #dfdfdf;\n\n    tr:first-child>*:first-child {\n      border-start-start-radius: 4px;\n    }\n\n    tr:first-child>*:last-child {\n      border-start-end-radius: 4px;\n    }\n\n    .ant-table-cell {\n      background-color: #f1f1f1;\n      padding: 16px;\n\n      font-family: \"Roboto\";\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 22px;\n      color: #4d4d4d;\n    }\n  }\n\n  .ant-table-tbody {\n    border: 1px solid;\n    border-color: #dfdfdf;\n\n    .ant-table-cell {\n      background-color: #ffffff;\n      padding: 16px;\n\n      font-family: \"Roboto\";\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 22px;\n      color: #4d4d4d;\n\n    }\n  }\n}\n\n.ant-pagination {\n\n  .ant-pagination-item {\n    border: 1px solid;\n    border-color: #bebebe;\n    border-radius: 2px;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-weight: 400;\n    color: #4d4d4d;\n    text-align: center;\n  }\n\n  .ant-pagination-item-active {\n    border: 1px solid;\n    border-color: #0f69b4;\n    border-radius: 2px;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-weight: 400;\n    color: #0f69b4;\n    text-align: center;\n  }\n\n  .ant-pagination-options .ant-select-selector {\n    border: 1px solid;\n    border-color: #bebebe;\n    border-radius: 2px;\n    font-family: \"Roboto\";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 21px;\n    color: #4d4d4d;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
